module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section07_01_american-village-000e7af5ab91b0e981547b2a25737079.jpg";